package com.eladfinish.bible.contest.domain

private fun List<String>.mergeSamuel(): List<String> {
    return this
        .map { book ->
            when (book) {
                "שמואל א", "שמואל ב" -> "שמואל"
                else -> book
            }
        }
        .distinct()
}

private fun List<String>.mergeMelachim(): List<String> {
    return this
        .map { book ->
            when (book) {
                "מלכים א", "מלכים ב" -> "מלכים"
                else -> book
            }
        }
        .distinct()
}

private fun List<String>.mergeDivreiHayamim(): List<String> {
    return this
        .map { book ->
            when (book) {
                "דברי הימים א", "דברי הימים ב" -> "דברי הימים"
                else -> book
            }
        }
        .distinct()
}

private fun List<String>.mergeEzraAndNechemia(): List<String> {
    return this
        .map { book ->
            when (book) {
                "עזרא", "נחמיה" -> "עזרא ונחמיה"
                else -> book
            }
        }
        .distinct()
}

private fun List<String>.mergeTwelveProphets(): List<String> {
    return this
        .map { book ->
            when (book) {
                "הושע",
                "יואל",
                "עמוס",
                "עובדיה",
                "יונה",
                "מיכה",
                "נחום",
                "חבקוק",
                "צפניה",
                "חגי",
                "זכריה",
                "מלאכי",
                    -> "שנים עשר"

                else -> book
            }
        }
        .distinct()
}

internal fun List<String>.mergeAllSplitBooks(): List<String> {
    return this
        .mergeSamuel()
        .mergeMelachim()
        .mergeTwelveProphets()
        .mergeEzraAndNechemia()
        .mergeDivreiHayamim()
}
